const _env = process.env.VUE_APP_MODE;
const mkLeadsUrlOverride = process.env.VUE_APP_MK_LEADS_URL;
const agentHubUrlOverride = process.env.VUE_APP_AGENT_HUB_URL;

let {
  appUrl,
  baseUrl,
  onlineUrl,
  mkLeadsUrl,
  homeUrl,
  passportUrl,
  resUrl,
  lang,
  imgRes,
  fileUrl,
  loginUrl,
  payUrl,
  presentUrl,
  previewstatic,
  partDrawingUrl,
  ossUrlLink,
  smarturl,
  outApiGwUrl,
  agentHubUrl,
  companyLogoUrl,url3D
}  = {};

switch(_env) {
  case 'development':
    appUrl = 'https://dev-app.haizol.com';
    baseUrl = 'https://dev-api.haizol.com';
    onlineUrl = 'https://dev-online.haizol.com';
    homeUrl = 'https://dev-cn.haizol.com';
    passportUrl = 'https://dev-passport-api.haizol.com';
    imgRes = "https://qa-res.haizol.com/marketing/saas/console-supplier/";//图片静态资源
    resUrl = 'https://dev-res.haizol.com';
    lang = "lang-h-dev";
    fileUrl = 'https://dev-file.haizol.com';
    loginUrl = 'https://dev-passport.haizol.com';
    payUrl = 'https://dev-oss-api.haizol.com';
    presentUrl = 'https://dev-home.haizol.com';
    previewstatic = 'https://dev-res.haizol.com/preview-static';
    partDrawingUrl = "https://dev-res.haizol.com/preview-thumbnail-static?code="; // 零件图
    companyLogoUrl= "https://dev-res.haizol.com/attachments/public";
    ossUrlLink="https://dev-oss.haizol.com/"
    smarturl = "https://dev-iq.haizol.com"
    outApiGwUrl = 'https://dev-out-api-gw.haizol.com';
    agentHubUrl = outApiGwUrl;
    url3D = "https://static.haizol.com";
    break;
  case 'qa':
    appUrl = 'https://qa-app.haizol.com';
    baseUrl = 'https://qa-api.haizol.com';
    onlineUrl = 'https://qa-online.haizol.com';
    homeUrl = 'https://qa-cn.haizol.com';
    passportUrl = 'https://qa-passport-api.haizol.com';
    imgRes = "https://qa-res.haizol.com/marketing/saas/console-supplier/";//图片静态资源
    resUrl = 'https://qa-res.haizol.com';
    lang = "lang-h-qa";
    fileUrl = 'https://qa-file.haizol.com';
    loginUrl = 'https://qa-passport.haizol.com';
    payUrl = 'https://qa-oss-api.haizol.com';
    presentUrl = 'https://qa-home.haizol.com';
    previewstatic = 'https://qa-res.haizol.com/preview-static';
    partDrawingUrl = "https://qa-res.haizol.com/preview-thumbnail-static?code="; // 零件图
    ossUrlLink="https://qa-oss.haizol.com/"
    smarturl = "https://qa-iq.haizol.com"
    outApiGwUrl = 'https://qa-out-api-gw.haizol.com';
    agentHubUrl = outApiGwUrl;
    companyLogoUrl= "https://qa-res.haizol.com/attachments/public";
    url3D = "https://static.haizol.com";
    break;
  case 'pre':
    appUrl = 'https://pre-app.haizol.com';
    baseUrl = 'https://pre-api.haizol.com';
    onlineUrl = 'https://pre-online.haizol.com';
    homeUrl = 'https://pre-cn.haizol.com';
    passportUrl = 'https://pre-passport-api.haizol.com';
    imgRes = "https://pre-res.haizol.com/marketing/saas/console-supplier/";//图片静态资源
    resUrl = 'https://pre-res.haizol.com';
    lang = "lang-h-pre";
    fileUrl = 'https://pre-file.haizol.com';
    loginUrl = 'https://pre-passport.haizol.com';
    payUrl = 'https://pre-oss-api.haizol.com';
    presentUrl = 'https://pre-home.haizol.com';
    previewstatic = 'https://pre-res.haizol.com/preview-static';
    partDrawingUrl = "https://pre-res.haizol.com/preview-thumbnail-static?code="; // 零件图
    companyLogoUrl= "https://pre-res.haizol.com/attachments/public";
    ossUrlLink="https://pre-oss.haizol.com/"
    smarturl = "https://pre-iq.haizol.com"
    outApiGwUrl = 'https://pre-out-api-gw.haizol.com';
    agentHubUrl = outApiGwUrl;
    url3D = "https://static.haizol.com";
    break;
  case 'production':
    appUrl = 'https://app.haizol.com';
    baseUrl = 'https://api.haizol.com';
    onlineUrl = 'https://www.haizol.com';
    homeUrl = 'https://cn.haizol.com';
    passportUrl = 'https://passport-api.haizol.com';
    imgRes = "https://res.haizol.com/marketing/saas/console-supplier/";//图片静态资源
    resUrl = 'https://res.haizol.com';
    lang = "lang-h";
    fileUrl = 'https://file.haizol.com';
    loginUrl = 'https://passport.haizol.com';
    payUrl = 'https://oss-api.haizol.com';
    presentUrl = 'https://home.haizol.com';
    previewstatic = 'https://res.haizol.com/preview-static';
    partDrawingUrl = "https://res.haizol.com/preview-thumbnail-static?code="; // 零件图
    companyLogoUrl= "https://res.haizol.com/attachments/public";
    ossUrlLink="https://oss.haizol.com/"
    smarturl = "https://iq.haizol.com"
    outApiGwUrl = 'https://out-api-gw.haizol.com';
    agentHubUrl = outApiGwUrl;
    url3D = "https://static.haizol.com";
    break;
  default: 
    appUrl = 'https://app.haizol.com';
    baseUrl = 'https://api.haizol.com';
    onlineUrl = 'https://www.haizol.com';
    homeUrl = 'https://cn.haizol.com';
    passportUrl = 'https://passport-api.haizol.com';
    imgRes = "https://res.haizol.com/marketing/saas/console-supplier/";//图片静态资源
    resUrl = 'https://res.haizol.com';
    lang = "lang-h";
    fileUrl = 'https://file.haizol.com';
    loginUrl = 'https://passport.haizol.com';
    payUrl = 'https://oss-api.haizol.com';
    presentUrl = 'https://home.haizol.com';
    previewstatic = 'https://res.haizol.com/preview-static',
    partDrawingUrl = "https://res.haizol.com/preview-thumbnail-static?code="; // 零件图
    companyLogoUrl= "https://res.haizol.com/attachments/public";
    ossUrlLink="https://oss.haizol.com/"
    smarturl = "https://iq.haizol.com"
    outApiGwUrl = 'https://out-api-gw.haizol.com';
    agentHubUrl = outApiGwUrl;
    url3D = "https://static.haizol.com";
}

function resolveLocalUrlOverride(overrideValue, defaultValue) {
  if (overrideValue === undefined) return defaultValue;
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  if (!overrideValue) return origin;
  if (overrideValue.startsWith('/')) return `${origin}${overrideValue}`;
  return overrideValue;
}

mkLeadsUrl = resolveLocalUrlOverride(mkLeadsUrlOverride, onlineUrl);
agentHubUrl = resolveLocalUrlOverride(agentHubUrlOverride, agentHubUrl);

export {
  appUrl,
  baseUrl,
  onlineUrl,
  mkLeadsUrl,
  homeUrl,
  passportUrl,
  resUrl,
  lang,
  imgRes,
  fileUrl,
  loginUrl,
  payUrl,
  presentUrl,
  previewstatic,
  partDrawingUrl,
  ossUrlLink,
  smarturl,
  outApiGwUrl,
  agentHubUrl,
  companyLogoUrl,
  url3D
}
